import { CresoTextLogo } from "@core/components/logo/creso-logo";
import { BrandLogo } from "./brand-logo";
import { PHONE_HEIGHT } from "./phone-frame";
import { BrandingPreviewValues } from "./types";

export const VCARD_WIDTH = 384;

export function VCardPreview({
  brandName,
  tagLine,
  logoUrl,
  distributorName,
  arnCode,
  qrUrl,
}: BrandingPreviewValues) {
  return (
    <div
      style={{ width: VCARD_WIDTH, height: PHONE_HEIGHT }}
      className="flex flex-col items-center px-8 pt-20 pb-14 text-center rounded-2xl border border-stone-200 bg-gradient-to-b from-slate-200 via-white to-white text-stone-900 shadow-xl"
    >
      <BrandLogo
        url={logoUrl}
        name={brandName}
        className="size-20 rounded-2xl text-2xl"
      />
      <span className="mt-4 text-xl font-semibold">{brandName}</span>
      <span className="text-stone-500">{tagLine}</span>
      <span className="mt-8 font-semibold">{distributorName}</span>
      <span className="text-stone-500">ARN-{arnCode}</span>
      <span className="text-stone-500">
        AMFI registered Mutual Fund Distributor
      </span>
      {qrUrl && (
        <img src={qrUrl} alt="Brand QR code" className="mt-12 size-40" />
      )}
      <div className="mt-auto flex flex-col items-center gap-1 [&_svg]:text-slate-900">
        <span className="text-sm text-stone-500">Powered by</span>
        <CresoTextLogo />
      </div>
    </div>
  );
}
